<template>
  <comBox style="height:100%;">
    <template v-slot:name><h3>{{$store.state.module1.isChina?'污染曲线':'contamination curve'}}(GMT+8)</h3></template>
    <template v-slot:other>
      <form class="selectMode">
        <input type="radio" v-model="zonghe" :value="true" @click="zonghe=!zonghe">{{$store.state.module1.isChina?'综合':'synthesize'}}
        <el-select v-model="devParam" >
          <el-option disabled value="">{{$store.state.module1.isChina?'请选择参数':'select parameter'}}</el-option>
          <el-option v-for="(item,index) in areaInfo.params" :key="index" :value="item.name" :label="item.nickname"></el-option>
        </el-select>
        <el-date-picker
              v-model="timeValue"
              type="daterange"
              :range-separator="$store.state.module1.isChina?'至':'to'"
              :start-placeholder="$store.state.module1.isChina?'开始日期':'start'"
              :end-placeholder="$store.state.module1.isChina?'结束日期':'end'">
        </el-date-picker>
      </form>
    </template>
    <template v-slot:content>
      <p style="textAlign:right;paddingTop:0.1rem;paddingRight:0.1rem;height:0.2rem;"> <span v-for="dev in devId" :key="dev.code"><span class="qiuqiu" :style="{background: dev.color}"></span>{{dev.dev}}</span></p>
      <div id="zhedianE" v-if="io===false"></div>
      <img v-if="io" style="marginTop:0.4rem;" src="../../assets/img/table.png"/>
    </template>
  </comBox>
</template>

<script>
import { Mixin } from '../../mixins/index.js'
import { stringTime, requestData } from '../../assets/js/commont.js'
import { Line } from '@antv/g2plot'
import comBox from '../comBox/comBox.vue'
export default {
  name: 'zhedianEh',
  inject: ['reToken'],
  mixins: [Mixin],
  props: ['devArr', 'devId', 'areaId', 'devParams', 'dt'],
  components: {
    comBox
  },
  data () {
    return {
      timeId1: null,
      timeId2: null,
      airData: [],
      timedata: [],
      myChart: null,
      devParam: 'pm25',
      startTime: '',
      endTime: '',
      timeValue: '',
      io: true,
      zonghe: false,
      dateValue: null,
      series: null,
      standard: 35,
      rawDeviceLog: null,   // 缓存最近一次设备原始数据
      rawAreaLog: null,     // 缓存最近一次区域原始数据
    }
  },
  beforeDestroy () {
    window.onresize = null
    this.myChart = null
  },
  methods: {
      // 对单个数据点应用单位转换
      applyUnitConversion(dataItem, param) {
        const unit = JSON.parse(window.localStorage.getItem('unit'));
        if (!unit || !dataItem[param]) return;
        let factor = 1;
        // 对应参数的转换因子（与父组件逻辑完全一致）
        if (param === 'pm25' && unit.pm25 === 'mg/m³') factor = 0.001;
        else if (param === 'pm10' && unit.pm10 === 'mg/m³') factor = 0.001;
        else if (param === 'tvoc' && unit.tvoc === 'mg/m³') factor = 0.0013;
        else if (param === 'hcho' && unit.hcho === 'mg/m³') factor = 0.0012;
        if (factor !== 1) {
          dataItem[param] = parseFloat((dataItem[param] * factor).toFixed(4));
        }
      },

      // 处理设备数据（时间格式化、特殊除10、单位转换）
      processDeviceData(rawLog, param) {
        const result = [];
        this.devId.forEach((code, index) => {
          if (rawLog[code.dev] && rawLog[code.dev].length) {
            rawLog[code.dev].forEach(item => {
              const copy = { ...item };
              copy.time = copy.time.slice(5, -3);
              copy[param] = parseFloat(copy[param]);
              if (this.showDb && param === 'co2') {
                copy[param] = parseFloat((copy[param] / 10).toFixed(1));
              }
              this.applyUnitConversion(copy, param);
              result.push(copy);
            });
          }
        });
        return result;
      },

      // 处理区域数据
      processAreaData(rawLog, param) {
        const areaData = rawLog[this.areaId] || [];
        return areaData.map(item => {
          const copy = { ...item };
          copy.time = copy.time.slice(5, -3);
          copy[param] = parseFloat(copy[param]);
          if (this.showDb && param === 'co2') {
            copy[param] = parseFloat((copy[param] / 10).toFixed(1));
          }
          this.applyUnitConversion(copy, param);
          return copy;
        });
      },

      // 公共方法：重新应用单位转换并重绘
      reconvertUnit() {
        if (this.rawDeviceLog) {
          this.dateValue = this.processDeviceData(this.rawDeviceLog, this.devParam);
        } else if (this.rawAreaLog) {
          this.dateValue = this.processAreaData(this.rawAreaLog, this.devParam);
        }
        if (this.dateValue && this.dateValue.length) {
          this.initChart();
        }
      },
    reM () {
      if (this.line) {
        this.line.destroy()
      }
    },
    choseInit () {
      var self = this
      var am = [
        {
          type: 'text',
          position: ['min', self.standard],
          content: '参考值' + self.standard,
          offsetY: 8,
          style: {
            textBaseline: 'bottom'
          }
        },
        {
          type: 'line',
          start: ['min', self.standard],
          end: ['max', self.standard],
          style: {
            stroke: '#F4664A',
            lineDash: [2, 2]
          }
        }
      ]
      if (this.series) {
        this.line = new Line('zhedianE', {
          data: this.dateValue,
          lineStyle: {
            lineWidth: 1
          },
          autoFit: true,
          padding: 'auto',
          xField: 'time',
          nice: true,
          yField: this.devParam,
          seriesField: 'dcode',
          color: this.color,
          annotations: self.standard ? am : '',
          slider: {
            start: 0,
            end: 1
          },
          xAxis: {
            tickCount: 8,
            label: {
              style: {
                fontSize: 12
              }
            }
          },
          yAxis: {
            tickCount: 2,
            label: {
              // 数值格式化为千分位
              formatter: (v) => `${parseInt(v)}`
            }
          },
          smooth: true,
          legend: false,
          animation: {
            appear: {
              animation: 'path-in',
              duration: 3000
            }
          }
        })
      } else {
        this.line = new Line('zhedianE', {
          data: this.dateValue,
          lineStyle: {
            lineWidth: 1
          },
          padding: 'auto',
          xField: 'time',
          autoFit: true,
          nice: true,
          grid: null,
          smooth: true,
          annotations: self.standard ? am : '',
          slider: {
            start: 0,
            end: 1
          },
          xAxis: {
            tickCount: 8,
            label: {
              style: {
                fontSize: 12
              }
            }
          },
          yAxis: {
            tickCount: 2,
            label: {
              // 数值格式化为千分位
              formatter: (v) => `${parseInt(v)}`
            }
          },
          legend: false,
          yField: this.devParam,
          color: ['#1979C9'],
          animation: {
            appear: {
              animation: 'path-in',
              duration: 3000
            }
          }
        })
      }
    },
    // 初始化折点图标
    initChart () {
      if (this.line) {
        this.reM()
        this.choseInit()
        this.line.render()
      } else {
        this.choseInit()
        this.line.render()
      }
    },
    getDevLog () {
      var arr = []
      this.devId.forEach(item => {
        arr.push(item.dev)
      })
      var time = stringTime(this.$myTime())
      var time1 = this.endTime ? stringTime(this.endTime) : 0
      var time2 = this.startTime ? stringTime(this.startTime) : 0
      var data = {
        account: window.localStorage.getItem('account'),
        device_code: arr.join(','),
        max_time: time1,
        min_time: time2,
        parameter: this.dt.join(','),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getDeviceLog(requestData(data))
    },
    // 获取综合数据 ----------------------------------
    getALog () {
      var time = stringTime(this.$myTime())
      var time1 = this.endTime ? stringTime(this.endTime) : 0
      var time2 = this.startTime ? stringTime(this.startTime) : 0
      var data = {
        account: window.localStorage.getItem('account'),
        area_ids: this.areaId,
        max_time: time1,
        min_time: time2,
        parameter: this.dt.join(','),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getAreaLog(requestData(data))
    }
  },
  created () {
    this.endTime = this.$myTime()
    this.startTime = new Date(this.endTime.getTime() - 60 * 60 * 1000)
    // 销毁定时器最终写法
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.timeId1)
      clearInterval(this.timeId2)
    })
  },
  watch: {
    dateValue (value) {
      this.$nextTick(() => {
        if (value.length) {
          this.initChart()
        }
      })
    },
    timeValue (value) { // 没问题ok
      this.$nextTick(() => {
        if (value) {
          this.startTime = new Date(value[0])
          this.endTime = new Date(new Date(value[1]).getTime() + 1000 * 60 * 60 * 24 - 1000)
          var difTime = this.endTime.getTime() - this.startTime.getTime()
          if (difTime > 30 * 24 * 60 * 60 * 1000) {
            this.$message({
              message: this.$store.state.module1.isChina ? '时间间隔不能超过30天' : 'The time interval cannot exceed 30 days',
              type: 'warning'
            })
          } else if ((this.endTime.getTime() - 1000 * 60 * 60 * 24) > this.$myTime().getTime()) {
            this.$message({
              message: this.$store.state.module1.isChina ? '时间不能超过当前时间' : 'The time cannot exceed the current time',
              type: 'warning'
            })
          } else {
            if (this.zonghe) {
              this.getALog()
            } else {
              this.getDevLog()
            }
          }
        }
      })
    },
    // 监听设备更换获取数据
    devId (value) {
      this.$nextTick(() => {
        if (value.length > 3) {
          value.pop()
        } else if (value.length === 0) {
          this.dateValue = []
          this.series = null
          this.zonghe = true
        } else {
          this.color = []
          value.forEach(item => {
            this.color.push(item.color)
          })
          clearInterval(this.timeId2)
          this.zonghe = false
          if (this.startTime && this.endTime) {

          } else {
            this.endTime = this.$myTime()
            this.startTime = new Date(this.endTime.getTime() - 60 * 60 * 1000)
          }
          this.getDevLog()
          this.timeId2 = setInterval(() => { // 有问题3次设备变化3个循环
            this.endTime = this.$myTime()
            this.startTime = new Date(this.endTime.getTime() - 60 * 60 * 1000)
            this.timeValue = ''
            this.getDevLog()
          }, 1000 * 60)
        }
      })
    },
    deviceLog (value) {
      this.$nextTick(() => {
        if (value) {
              this.rawDeviceLog = value;          // 保存原始数据
              this.dateValue = this.processDeviceData(value, this.devParam);
              this.io = false;
              this.series = 'decode';
              this.$nextTick(() => this.initChart());
            }
      })
    },
    // 监听区域数据
    areaLog (value) {
      this.$nextTick(() => {
        if (value) {
              this.rawAreaLog = value;            // 保存原始数据
              this.dateValue = this.processAreaData(value, this.devParam);
              this.io = false;
              this.$nextTick(() => this.initChart());
            }
      })
    },
    devParam (value) { // 第三步
      console.log(value)
      if (value === 'pm25') {
        this.standard = 35
      } else if (value === 'hcho') {
        this.standard = 80
      } else if (value === 'co2') {
        this.standard = 1000
      } else if (value === 'temperature') {
        this.standard = 26
      } else if (value === 'humidity') {
        this.standard = 55
      } else {
        this.standard = 0
      }
      this.$nextTick(() => {
        this.areaInfo.params.forEach(item => {
          if (item.nickname === 'noise') {
            this.$store.commit('setDb', true)
            window.localStorage.setItem('showDb', true)
          } else {
            this.$store.commit('setDb', false)
            window.localStorage.setItem('showDb', false)
          }
        })
        if (this.rawDeviceLog && !this.zonghe) {
          this.dateValue = this.processDeviceData(this.rawDeviceLog, value);
          this.initChart();
        } else if (this.rawAreaLog && this.zonghe) {
          this.dateValue = this.processAreaData(this.rawAreaLog, value);
          this.initChart();
        }
        if (this.devId.length) {
          this.zonghe ? this.getALog() : this.getDevLog();
        } else {
          this.getALog();
        }
      })
    },
    zonghe (newvalue, oldvalue) { // 第二步
      this.$nextTick(() => {
        if (newvalue === true) {
          clearInterval(this.timeId2)
          this.$emit('clearBlue')
          if (this.startTime && this.endTime) {

          } else {
            this.endTime = this.$myTime()
            this.startTime = new Date(this.endTime.getTime() - 60 * 60 * 1000)
          }
          this.getALog()
          this.timeId1 = setInterval(() => {
            this.$emit('clearBlue')
            this.endTime = this.$myTime()
            this.startTime = new Date(this.endTime.getTime() - 60 * 60 * 1000)
            this.timeValue = ''
            this.getALog()
          }, 1000 * 60)
        } else {
          this.io = true
          clearInterval(this.timeId1)
        }
      })
    },
    areaId (value) { // 第一步
      this.$nextTick(() => {
        if (this.zonghe === true) {
          this.getALog()
        } else {
          this.zonghe = true
        }
      })
    }
  }
}
</script>

<style scoped>
.selectMode{
  display:flex;
  align-items:center;
}
.selectMode span:nth-child(2){
 color:#01A3FF;
 margin-right:0.1rem;
}
.selectMode span:nth-child(4){
 color:#FF5679;
}
.selectMode select{
  border:2px solid black;
  padding:0.05rem 0.1rem;
  color:black;
}
.selectMode label{
  margin-right:0.1rem;
  font-size:0.16rem;
}
#zhedianE{
margin-top:0.1rem;
width:11.5rem;
height:calc(100% - 0.8rem);
}
.qiuqiu{
  display:inline-block;
  width:0.1rem;
  height:0.1rem;
  border-radius:50%;
  margin:0 0.1rem;
  background:red;
}
</style>
